<template>
  <v-container fluid>
    <a-form layout="vertical">
      <a-row :gutter="8">
        <a-col :span="24" :xxl="4" :xl="6" :lg="8" :md="12">
          <a-form-item label="日期">
            <a-range-picker v-model="queryForm.day_range" :mode="['date', 'date']" :placeholder="['开始日期', '结束日期']"
              :locale="locale" :allowClear="false" format="YYYY-MM-DD" valueFormat="YYYY-MM-DD" style="width:100%;" />
          </a-form-item>
        </a-col>
        <a-col :span="24" :xxl="2" :xl="3" :lg="4" :md="6">
          <a-form-item label="车牌号">
            <a-input v-model="queryForm.vehicle_number" placeholder="车牌号" style="width:100%;"
              @keyup.enter="getdata()" />
          </a-form-item>
        </a-col>
        <a-col :span="24" :xxl="2" :xl="3" :lg="4" :md="6">
          <a-form-item label="平台">
            <a-select v-model="queryForm.platform" :options="[
              { label: '星星充电', value: '星星充电' },
              { label: '五牛新能源', value: '五牛新能源' },
              { label: '特来电', value: '特来电' },
              { label: '云快充', value: '云快充' },
              { label: '新电途', value: '新电途' },
            ]" :allowClear="true" placeholder="请选择" style="width:100%;">
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="24" :xxl="2" :xl="3" :lg="4" :md="6">
          <a-form-item label=".">
            <a-space>
              <a-button @click="getdata()" type="primary">
                查询
              </a-button>
              <a-button @click="() => $refs.uploadRef.showupload()" class="btn-cyan">
                <a-icon type="upload" />上传充电数据
              </a-button>
              <a-button @click="download" class="btn-success">
                <a-icon type="download" />下载充电数据
              </a-button>
            </a-space>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
    <a-tabs v-model="queryForm.match_state" size="small" @change="getdata()">
      <a-tab-pane :key="0" tab="未匹配"></a-tab-pane>
      <a-tab-pane :key="1" tab="已匹配"></a-tab-pane>
    </a-tabs>
    <v-card tile class="mt-2">
      <a-table size="small" :columns="headers" :data-source="summaryList" :pagination="false"
        :locale="{ emptyText: '暂无数据' }" :scroll="{ x: width, y: height }" row-key="_id">
        <template slot="title">
          <div class="d-flex align-center pl-2">
            <span>共 {{ length }} 页 / {{ count }} 条数据</span>
            <v-menu bottom offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn small outlined v-bind="attrs" v-on="on" class="ml-2 grey lighten-3">
                  {{ limit }}/页
                </v-btn>
              </template>
              <v-list>
                <v-list-item v-for="(item, index) in pages" @click="limit = item.value" :key="index">
                  <v-list-item-title>{{ item.value }}/页</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </template>
        <template slot="order_number" slot-scope="text, record">
          <span :class="{ 'font-weight-bold primary--text': record._isSummary }">
            {{ text }}
          </span>
        </template>
        <template slot="vehicle_number" slot-scope="text, record">
          <span :class="{ 'font-weight-bold primary--text': record._isSummary }">
            {{ text }}
          </span>
        </template>
        <template slot="kwh" slot-scope="text, record">
          <span :class="{ 'font-weight-bold primary--text': record._isSummary }">
            {{ Number(text) === 0 ? '0' : text }}
          </span>
        </template>
        <template slot="kwh1" slot-scope="text, record">
          <span :class="{ 'font-weight-bold primary--text': record._isSummary }">
            {{ Number(text) === 0 ? '0' : text }}
          </span>
        </template>
        <template slot="kwh2" slot-scope="text, record">
          <span :class="{ 'font-weight-bold primary--text': record._isSummary }">
            {{ Number(text) === 0 ? '0' : text }}
          </span>
        </template>
        <template slot="kwh3" slot-scope="text, record">
          <span :class="{ 'font-weight-bold primary--text': record._isSummary }">
            {{ Number(text) === 0 ? '0' : text }}
          </span>
        </template>
        <template slot="kwh4" slot-scope="text, record">
          <span :class="{ 'font-weight-bold primary--text': record._isSummary }">
            {{ Number(text) === 0 ? '0' : text }}
          </span>
        </template>
        <template slot="kwh5" slot-scope="text, record">
          <span :class="{ 'font-weight-bold primary--text': record._isSummary }">
            {{ Number(text) === 0 ? '0' : text }}
          </span>
        </template>
        <template slot="electric_fee" slot-scope="text, record">
          <span :class="{ 'font-weight-bold primary--text': record._isSummary }">
            {{ text }}
          </span>
        </template>
        <template slot="service_fee" slot-scope="text, record">
          <span :class="{ 'font-weight-bold primary--text': record._isSummary }">
            {{ text }}
          </span>
        </template>
        <template slot="total_fee" slot-scope="text, record">
          <span :class="{ 'font-weight-bold primary--text': record._isSummary }">
            {{ text }}
          </span>
        </template>
        <template slot="price" slot-scope="text, record">
          <span :class="{ 'font-weight-bold primary--text': record._isSummary }">
            {{ text }}
          </span>
        </template>
        <template slot="create_time" slot-scope="text, record">
          {{ record._isSummary ? '' : record.create_time | dateFormat('YYYY-MM-DD HH:mm:ss') }}
        </template>
        <template slot="match_state" slot-scope="text, record">
          <template v-if="!record._isSummary">
            <v-btn v-if="record.match_state === 1" color="primary" text tile small @click="showmatchresult(record)">
              已匹配
            </v-btn>
            <span v-else>未匹配</span>
          </template>
        </template>
        <!-- <template slot="action" slot-scope="text, record">
          <a-space>
            <a-popconfirm title="删除充电记录" ok-text="确定" cancel-text="取消" @confirm="remove(record._id)">
              <v-btn text tile color="error"> 删除 </v-btn>
            </a-popconfirm>
          </a-space>
        </template> -->
      </a-table>
      <v-pagination v-if="length > 1" v-model="page" :page="page" :length="length" total-visible="10" />
    </v-card>
    <v-dialog v-model="matchmodel" persistent max-width="600px">
      <v-card>
        <v-card-title class="grey lighten-4 pa-2 text-subtitle-1 mb-4 d-flex justify-space-between">
          匹配详情
          <v-icon @click="() => matchmodel = false">mdi-close</v-icon>
        </v-card-title>
        <v-card-text>
          <a-table size="small" :columns="matchheaders" :data-source="matchresult" :pagination="false"
            :locale="{ emptyText: '暂无数据' }">
          </a-table>
        </v-card-text>
      </v-card>
    </v-dialog>
    <UploadTask ref="uploadRef" modelTitle="上传充电记录" :Category="true"
      :alertText="`上传Excel文件需包含 <span class='error--text'>车牌号</span>、<span class='error--text'>开始时间</span>、<span>结束时间</span>、<span class='error--text'>充电时长</span>、<span class='error--text'>充电量</span>、<span>充电费</span>、<span class='error--text'>服务费</span>、<span>总额</span>、<span>充电桩地点</span> 字段。`"
      uploadType="vehiclerecharge" :templateFile="templateFile" />
  </v-container>
</template>

<script>
import _ from "underscore";
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import { mapState } from "vuex";
import UploadTask from "@/components/uploadtask.vue";
export default {
  name: "Recharge",
  data() {
    return {
      locale,
      queryForm: {
        day_range: [],
        vehicle_number: "",
        platform: undefined,
        match_state: 0,
      },
      pages: [
        { text: '20/页', value: 20 },
        { text: '50/页', value: 50 },
        { text: '100/页', value: 100 },
        { text: '200/页', value: 200 },
      ],
      headers: [
        { title: "订单号", dataIndex: "order_number", scopedSlots: { customRender: "order_number" }, width: 150, align: "center" },
        { title: "车牌号", dataIndex: "vehicle_number", scopedSlots: { customRender: "vehicle_number" }, width: 120, align: "center" },
        { title: "状态", dataIndex: "match_state", scopedSlots: { customRender: "match_state" }, width: 120, align: "center" },
        { title: "开始时间", dataIndex: "start_time", scopedSlots: { customRender: "start_time" }, width: 120, align: "center" },
        { title: "结束时间", dataIndex: "end_time", scopedSlots: { customRender: "end_time" }, width: 120, align: "center" },//套牌号
        { title: "充电时长(分)", dataIndex: "duration", scopedSlots: { customRender: "duration" }, width: 120, align: "center" },
        { title: "充电量(度)", dataIndex: "kwh", scopedSlots: { customRender: "kwh" }, width: 120, align: "center" },
        { title: "尖时(度)", dataIndex: "kwh1", scopedSlots: { customRender: "kwh1" }, width: 120, align: "center" },//元/月,包车费/月租,自动关联过来,临时车在调度计划里填写然后关联到路单和财务账单
        { title: "峰时(度)", dataIndex: "kwh2", scopedSlots: { customRender: "kwh2" }, width: 120, align: "center" },
        { title: "平时(度)", dataIndex: "kwh3", scopedSlots: { customRender: "kwh3" }, width: 180, align: "center" },
        { title: "谷时(度)", dataIndex: "kwh4", scopedSlots: { customRender: "kwh4" }, width: 120, align: "center" },
        { title: "深谷(度)", dataIndex: "kwh5", scopedSlots: { customRender: "kwh5" }, width: 120, align: "center" },
        { title: "充电费(元)", dataIndex: "electric_fee", scopedSlots: { customRender: "electric_fee" }, width: 120, align: "center" },
        { title: "服务费(元)", dataIndex: "service_fee", scopedSlots: { customRender: "service_fee" }, width: 120, align: "center" },
        { title: "总额(元)", dataIndex: "total_fee", scopedSlots: { customRender: "total_fee" }, width: 120, align: "center" },
        { title: "单价(元/度)", dataIndex: "price", scopedSlots: { customRender: "price" }, width: 120, align: "center" },
        { title: "地点", dataIndex: "location.address", scopedSlots: { customRender: "location.address" }, width: 120, align: "center" },
        { title: "平台", dataIndex: "platform", scopedSlots: { customRender: "platform" }, width: 120, align: "center" },
        { title: "上传时间", dataIndex: "create_time", scopedSlots: { customRender: "create_time" }, width: 180, align: "center" },
        // { title: "操作人", dataIndex: "opby", scopedSlots: { customRender: "opby" }, width: 120, align: "center" },
        // { title: "操作", dataIndex: "action", scopedSlots: { customRender: "action" }, width: 100, align: "center" },
      ],
      page: 1,
      limit: 20,
      list: [],
      length: 0,
      count: 0,
      height: 600,
      templateFile: {
        url: `${process.env.BASE_URL}template/充电数据导入模板.xlsx`,
        name: '充电数据导入模板.xlsx',
      },
      matchmodel: false,
      matchheaders: [
        { title: "邮路", dataIndex: "postroute", scopedSlots: { customRender: "postroute" } },
        { title: "派车单号", dataIndex: "dispatch_no", scopedSlots: { customRender: "dispatch_no" } },
        { title: "里程", dataIndex: "mileage", scopedSlots: { customRender: "mileage" } },
        { title: "费用", dataIndex: "electricityrecharge_fee", scopedSlots: { customRender: "electricityrecharge_fee" } },
        { title: "电量(kWh)", dataIndex: "electricityrecharge_kwh", scopedSlots: { customRender: "electricityrecharge_kwh" } },
      ],
      matchresult: [],
    };
  },
  computed: {
    ...mapState(["role", "username"]),
    width() {
      return _.reduce(this.headers, (a, b) => a + (b.width || 300), 0);
    },
    summaryList() {
      if (!this.list || this.list.length === 0) return [];
      const sum = (key) => this.list.reduce((acc, row) => acc + (Number(row[key]) || 0), 0);
      return [
        {
          _id: 'summary',
          _isSummary: true,
          order_number: '合计',
          kwh: Math.round(sum('kwh') * 100) / 100,
          kwh1: Math.round(sum('kwh1') * 100) / 100,
          kwh2: Math.round(sum('kwh2') * 100) / 100,
          kwh3: Math.round(sum('kwh3') * 100) / 100,
          kwh4: Math.round(sum('kwh4') * 100) / 100,
          kwh5: Math.round(sum('kwh5') * 100) / 100,
          electric_fee: Math.round(sum('electric_fee') * 100) / 100,
          service_fee: Math.round(sum('service_fee') * 100) / 100,
          total_fee: Math.round(sum('total_fee') * 100) / 100,
          price: (() => {
            const totalFee = Math.round(sum('total_fee') * 100) / 100;
            const totalKwh = Math.round(sum('kwh') * 100) / 100;
            return totalKwh ? (totalFee / totalKwh).toFixed(2) : '0.00';
          })(),
        },
        ...this.list,
      ];
    },
  },
  components: { UploadTask },
  watch: {
    page() {
      this.getdata();
    },
    limit() {
      if (this.page !== 1) this.page = 1;
      else this.getdata();
    },
  },
  mounted() {
    this.height = window.innerHeight - 350;
    window.onresize = (e) => {
      console.log("onresize", window.innerHeight);
      this.height = window.innerHeight - 350;
    };
    this.page = 1;
    this.list = [];
    this.length = 0;
    this.count = 0;
    let start_day = this.$moment().startOf('month').format('YYYY-MM-DD');
    let end_day = this.$moment().endOf('month').format('YYYY-MM-DD');
    this.queryForm = {
      day_range: [start_day, end_day],
      vehicle_number: "",
      platform: undefined,
      match_state: 0,
    };
  },
  activated() {
    this.getdata();
  },
  methods: {
    download() {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/electricityrecharge/list", { page: this.page, limit: this.limit, ...this.queryForm, action: "download" }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.$download(res.data.url, res.data.name);
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    getdata() {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/electricityrecharge/list", { page: this.page, limit: this.limit, ...this.queryForm }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.list = res.data.list;
          this.length = res.data.length;
          this.count = res.data.count;
          if (this.length > 0 && this.page > this.length) this.page = 1;
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    remove(_id) {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/electricityrecharge/remove", { _id }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.getdata();
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    showmatchresult(item) {
      this.matchresult = [
        ...(item.bills.length > 0 ? [
          {
            postroute: "合计",
            mileage: item.bills.reduce((a, b) => a.plus(b.mileage), this.$d()).toString(),
            electricityrecharge_fee: item.bills.reduce((a, b) => a.plus(b.electricityrecharge_fee), this.$d()).toString(),
            electricityrecharge_kwh: item.bills.reduce((a, b) => a.plus(b.electricityrecharge_kwh), this.$d()).toString(),
          }
        ] : []),
        ...item.bills,
      ];
      this.matchmodel = true;
    },
  },
};
</script>
<style lang="less" scoped>
/deep/ .ant-form-item {
  margin-bottom: 0;
}

/deep/ .ant-table-fixed-header .ant-table-scroll .ant-table-header {
  padding-bottom: 4px;
}

p {
  margin: 0;
}
</style>
